import { InjectionToken } from '@angular/core';

export const API_PREFIX = new InjectionToken<string>('');
